const initialState = {
	success: false,
	loading: false,
	error: null,
	districtAdminList: {
		data: null,
		loading: false,
		error: null,
	},
	addDistrictAdminResponse: {
		data: null,
		loading: false,
		error: null,
	},
	districtAdminDetails: {
    data: null,
    loading: false,
    error: null,
  },
	updateDistrictAdminResponse: {
    data: null,
    loading: false,
    error: null,
  },
};
  
const DistrictAdminReducer = (
	state = initialState,
	{ obj, type, error, payload, data }
) => {
	switch (type) {
		case "GET_ALL_DISTRICT_ADMIN":
			return {
				...state,
				districtAdminList: {
					...state.districtAdminList,
					loading: true,
				},
			};

		case "GET_ALL_DISTRICT_ADMIN_SUCCESS":
			return {
				...state,
				districtAdminList: {
					...state.districtAdminList,
					data,
					loading: false,
				},
			};

		case "GET_ALL_DISTRICT_ADMIN_FAIL":
			return {
				...state,
				districtAdminList: {
					...state.districtAdminList,
					error,
					loading: false,
				},
			};

		case "ADD_DISTRICT_ADMIN":
			return {
				...state,
				addDistrictAdminResponse: {
					...state.addDistrictAdminResponse,
					loading: true,
				},
			};

		case "ADD_DISTRICT_ADMIN_SUCCESS":
			return {
				...state,
				addDistrictAdminResponse: {
					...state.addDistrictAdminResponse,
					data,
					loading: false,
				},
			};

		case "ADD_DISTRICT_ADMIN_FAIL":
			return {
				...state,
				addDistrictAdminResponse: {
					...state.addDistrictAdminResponse,
					error,
					loading: false,
				},
			};
		case "RESET_ADD_DISTRICT_ADMIN":
			return {
				...state,
				addDistrictAdminResponse: {
					...state.addDistrictAdminResponse,
					data: null,
					loading: false,
					error: null,
				},
			};
		case "GET_DISTRICT_ADMIN_DETAILS":
			return {
				...state,
				districtAdminDetails: {
					...state.districtAdminDetails,
					loading: true,
				},
			};

		case "GET_DISTRICT_ADMIN_DETAILS_SUCCESS":
			return {
				...state,
				districtAdminDetails: {
					...state.districtAdminDetails,
					data,
					loading: false,
				},
			};

		case "GET_DISTRICT_ADMIN_DETAILS_FAIL":
			return {
				...state,
				districtAdminDetails: {
					...state.districtAdminDetails,
					error,
					loading: false,
				},
			};
		case "RESET_UPDATE_DISTRICT_ADMIN":
			return {
				...state,
				updateDistrictAdminResponse: {
					data: null,
					loading: false,
					error: null,
				},
			};
		case "UPDATE_DISTRICT_ADMIN":
			return {
				...state,
				updateDistrictAdminResponse: {
					...state.updateDistrictAdminResponse,
					loading: true,
				},
			};

		case "UPDATE_DISTRICT_ADMIN_SUCCESS":
			return {
				...state,
				updateDistrictAdminResponse: {
					...state.updateDistrictAdminResponse,
					data,
					loading: false,
				},
			};

		case "UPDATE_DISTRICT_ADMIN_FAIL":
			return {
				...state,
				updateDistrictAdminResponse: {
					...state.updateDistrictAdminResponse,
					error,
					loading: false,
				},
			};
		default:
			return state;
	}
};

export default DistrictAdminReducer;
  